(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: []
            },
            views: {
                'login@': {
                    templateUrl: 'app/layouts/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', '$window', 'Principal', function ($translate,$translatePartialLoader, $window, Principal) {
                    $translatePartialLoader.addPart('home');
                    if (Principal.isAuthenticated()) {
                        $window.location.href = "/";
                    }
                    return $translate.refresh();
                }]
            }
        });
    }
})();
